import * as actionTypes from "./constants";

const fetchmyplans = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_MYPLANS_ACTION,
      params: params,
    });
  };
};

const subscribeplan = (value, item, response,runnersubsrptnList) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SUBSCRIBE_PLAN_ACTION,
      value: value,
      item: item,
      datas: runnersubsrptnList,
      response: response,
    });
  };
};
const fetchSubscription = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_SUBSCRIPTION_ACTION,
      params: params,
    });
  };
};

const deleteSubscription = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_SUBSCRIPTION_ACTION,
      value: value,
    });
  };
};

const fetchPaymentmode = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_SUB_PAYMENTMODE_ACTION,
    });
  };
};

const fetchrunnerById = (item) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_RUNNER_BYID_ACTION,
      item: item,
    });
  };
};

const subscribeBankplan = (value, item,...runnersubsrptnList) => {
  console.log("!!!!!!!!^^^^^^runnersubsrptnList^^^^", runnersubsrptnList);
  return (dispatch) => {
    dispatch({
      type: actionTypes.SUBSCRIBE_BANKPLAN_ACTION,
      value: value,
      item: item,
      datas: runnersubsrptnList,
    });
  };
};

const fetchRunners = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_RUNNER_USER_ACTION,
    });
  };
};

const fetchSubscriptionLog = (item, params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_SUBSCRIPTION_LOG_ACTION,
      item: item,
      params: params,
    });
  };
};

const fetchTotalSubsrptn = (item) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_TOTALSUBSCRPTN_ACTION,
      item: item,
    });
  };
};

const fetchLog = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SUBSCRIBE_LOG_ACTION,
    });
  };
};
const fetchSubCargoSize = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_SUB_CARGOSIZE_ACTION,
    });
  };
};

const expiryStatusChange = (item) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.EXPIRE_STATUSCHANGE_ACTION,
      item: item,
    });
  };
};

const fetchHistorySubscription = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_HISTORYSUBSCRIPTION_ACTION,
      params: params,
    });
  };
};

const clearSubscrptnLog = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CLEAR_SUBSCRIPTIONLOG_ACTION,
    });
  };
};

export default {
  fetchmyplans,
  subscribeplan,
  fetchSubscription,
  deleteSubscription,
  fetchPaymentmode,
  fetchrunnerById,
  subscribeBankplan,
  fetchRunners,
  fetchSubscriptionLog,
  fetchTotalSubsrptn,
  fetchLog,
  fetchSubCargoSize,
  expiryStatusChange,
  fetchHistorySubscription,
  clearSubscrptnLog,
};
